/*
* https://github.com/wagerfield/parallax
*/

import Parallax from 'parallax-js';

// Mouse parallax
const parallaxItems = document.querySelectorAll('.js-parallax');

function mouseParallax(NodeList) {
    [].forEach.call(NodeList, item => { new Parallax(item); });
}

window.addEventListener('load', () => {
    if(parallaxItems.length) mouseParallax(parallaxItems);
});

document.addEventListener('DOMContentLoaded', () => {
    class ParallaxItem {
        constructor(el) {
            this.el = el;
            this.yValue = 0;
            this.currentY = 0;
            this.targetY = 0;
            this.ease = 0.08; 
            this.isVisible = false;

            this.init();
        }

        init() {
            const rawData = this.el.getAttribute('data-parallax');
            if (rawData) {
                try {
                    const cleanData = rawData.replace(/'/g, '"');
                    const parsed = JSON.parse(cleanData);
                    if (parsed.y) {
                        this.yValue = parseFloat(parsed.y);
                    }
                } catch (e) {
                    console.error('error', this.el, e);
                }
            }

            this.el.style.willChange = 'transform';
        }

        calculate(windowHeight) {
            if (!this.isVisible) return;

            const rect = this.el.getBoundingClientRect();
            const elementCenter = rect.top + rect.height / 2;
            const viewportCenter = windowHeight / 2;

            const distance = viewportCenter - elementCenter;

            this.targetY = -(distance / windowHeight) * this.yValue;
        }

        update() {
            if (!this.isVisible && Math.abs(this.targetY - this.currentY) < 0.1) return;

            this.currentY += (this.targetY - this.currentY) * this.ease;

            const y = Math.round(this.currentY * 100) / 100;

            this.el.style.transform = `translate3d(0, ${y}px, 0)`;
        }
    }

    const items = Array.from(document.querySelectorAll('[data-parallax]')).map(el => new ParallaxItem(el));

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            const item = items.find(i => i.el === entry.target);
            if (item) item.isVisible = entry.isIntersecting;
        });
    }, { rootMargin: '100px' });

    items.forEach(item => observer.observe(item.el));

    let windowHeight = window.innerHeight;
    window.addEventListener('resize', () => {
        windowHeight = window.innerHeight;
    });

    function animate() {
        items.forEach(item => item.calculate(windowHeight));
        items.forEach(item => item.update());

        requestAnimationFrame(animate);
    }

    animate();
});